<template>
  <PagesFund v-if="fundData" :object="fundData" />
  <div v-else class="error_not_found">
    <span class="code">404</span>
    <span>Not Found</span>
  </div>
</template>

<script setup>
import camelcaseKeys from 'camelcase-keys';

const { $useApi } = useNuxtApp();
const fundId = useRoute().params.id;
const headers = computed(() => useCustomRequestHeaders());

const { data: fundData } = await useFetch($useApi.fund.getFund(fundId), {
  key: `fund-${fundId}`,
  headers,
  transform: (response) => camelcaseKeys(response, { deep: true }),
});
</script>
